var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div"},[_c('img',{staticClass:"w100",attrs:{"src":"https://homeimage.ksaxshop.com/tou.png","alt":""}}),_c('div',{staticClass:"main"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }